import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'searchFilter'
})

/*
* Compares values in string format. Can filter array of objects or simple array with values
*/

export class SearchFilterPipe implements PipeTransform {

    lowerCaseString(value): string {
      if (!value) { return value; }
      if (typeof value !== 'string') { return value.toString().toLowerCase(); }
      return value.toLowerCase();
    }

    transform<T>(list: T[], searchValue: string | number, searchField: string): T[] {


      if (!searchValue) { return list; }
      const searchTerm = this.lowerCaseString(searchValue);

      /*
       * If searched in array of objects
       */
      if (searchField && typeof searchField === 'string') {
        return list.filter(item => {
          if (!item[searchField]) { return false; }

          const comparedItem = this.lowerCaseString(item[searchField]);
          return typeof comparedItem === 'string' && comparedItem.includes(searchTerm);
        });
      }

      /*
      * If searched in simple array with values
      */
      return list.filter(item => typeof this.lowerCaseString(item) === 'string' &&  this.lowerCaseString(item).includes(searchTerm));
    }

}
